import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCausativeAgentItems.success: {
            return action.payload;
        }

        case constants.getCausativeAgentItems.error: {
            return initialState;
        }

        case constants.getCausativeAgentItems.try: {
            return {};
        }

        default:
            return state;
    }
}